import {marked} from "marked";
import {decode} from "html-entities";

//parsing del message.markdown -> html per gestione link
export const parseMarkdown = (res) => {
  let html = '';
  if (res.messages.length > 0) {
    for (let message of res.messages) {
      if (message.type === 'text' && message.content.markdown) {
        let dec = decode(message.content.markdown);
        // decodifica più volte la response perché lato bot viene codificata e decodificata più volte. Mistero della fede
        while (true) {
          let red = decode(dec);
          if (red === dec) {
            break;
          }
          dec = red;
        }
        html += marked.parse(dec);
      }
    }
  }
  if (!html) html = noInfoMsg;
  return html;

  let dec = decode(m.content.markdown);
  while (true) {
    let red = decode(dec);
    if (red === dec) {
      break;
    }
    dec = red;
  }
}


//parsing references + choices
export const parseClientSideActions = (data) => {
  if (!data || !data.clientSideActions || !Array.isArray(data.clientSideActions)) return '';
  const refs = data.clientSideActions.find(a => a.setVariable?.scriptToExecute?.args?.[0]?.value);
  if (!refs) return '';

  try {
    const data = JSON.parse(refs.setVariable.scriptToExecute.args[0].value);

    // Caso 1: gestione references
    if (data.references && Array.isArray(data.references) && data.references.some(ref => ref.abstract !== null)) {
      let refHTML = '<div class="references"><h3>Riferimenti:</h3><ul>';
      for (let ref of data.references) {
        const abstractText = ref.abstract && ref.abstract !== 'null' ? ref.abstract : '';
        if (abstractText !== '') {
          refHTML += `<li><a href="${ref.url}">${ref.title}</a>: ${abstractText}</li>`;
        }
      }
      refHTML += '</ul></div>';
      return refHTML;
    }

    // Caso 2: gestione choices
    if (data.choices && Array.isArray(data.choices) && data.choices.length > 0) {
      let choiceHTML = '<div class="choices"><h3>Scegli un\'opzione:</h3><ul>';
      for (let choice of data.choices) {
        // puoi usare un data attribute per associare il value da usare dopo
        choiceHTML += `<li><button class="choice-btn" data-value="${choice.value}">${choice.label}</button></li>`;
      }
      choiceHTML += '</ul></div>';
      return choiceHTML;
    }

    return '';
  } catch (e) {
    console.error('Errore nel parsing dei dati', e);
    return '';
  }
}

//gestione delle choices
document.addEventListener('click', function(e) {
  if (e.target && e.target.classList.contains('choice-btn')) {
    const value = e.target.getAttribute('data-value');
    //todo da gestiore il value cliccato
    // console.log("Hai selezionato:", value);

  }
});

const noInfoMsg = 'Errore nel recupero del contenuto della risposta.'

export const getResponseReferences = (data) => {
  if (
    !data ||
    !data.clientSideActions ||
    !Array.isArray(data.clientSideActions) ||
    data.clientSideActions?.length === 0
  ) {
    return { references: [], collect_feedback: false };
  }

  let references = [];
  let collect_feedback = false;

  for (const action of data.clientSideActions) {
    const args = action.setVariable?.scriptToExecute?.args;
    if (!args) continue;

    for (const arg of args) {
      try {
        const parsed = JSON.parse(arg.value);
        if (parsed.references && Array.isArray(parsed.references)) {
          references.push(...parsed.references);
        }
        if (parsed.collect_feedback) {
          collect_feedback = true;
        }
      } catch (err) {
        console.warn('Impossibile fare parse JSON:', arg.value);
      }
    }
  }

  return { references, collect_feedback };
};


export const getResponseChoices = (data) => {
  if (!data || !data.clientSideActions || !Array.isArray(data.clientSideActions) && data.clientSideActions.length === 0 ) return {};
  let choices = [];
  for (const action of data.clientSideActions) {
    const args = action.setVariable.scriptToExecute.args;
    if (!args) return {};

    for (const arg of args) {
      const refs = JSON.parse(arg.value);
      if (refs.choices && Array.isArray(refs.choices) && refs.choices.length > 0) {
        choices.push(...refs.choices);
      }
    }
  }

  return choices;
}
